const ConfirmationModal = ({
  isOpen,
  title = "Confirm Action",
  message,
  details = [],
  onConfirm,
  onCancel,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmButtonClass = "bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-60 disabled:cursor-not-allowed",
  isLoading = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[9999] backdrop-blur-sm p-3 sm:p-4">
      <div className="bg-white rounded-xl w-full max-w-lg max-h-[90vh] sm:max-h-[80vh] overflow-y-auto shadow-2xl transform transition-all duration-300 scale-100">
        {/* Header with gradient */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white p-4 sm:p-6 rounded-t-xl">
          <h3 className="m-0 font-bold text-lg sm:text-xl tracking-wide">{title}</h3>
        </div>

        {/* Content */}
        <div className="p-4 sm:p-6">
          <p className="font-medium text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 leading-relaxed">
            {message}
          </p>

          {details.length > 0 && (
            <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg p-3 sm:p-5 mb-4 sm:mb-6 border border-gray-200">
              <h4 className="font-semibold text-gray-800 mb-2 sm:mb-3 text-xs sm:text-sm uppercase tracking-wide">
                Transfer Details
              </h4>
              {details.map((detail, index) => (
                <div
                  key={index}
                  className="flex flex-col xs:flex-row justify-between xs:items-center py-2 border-b border-gray-200 last:border-b-0 gap-1 xs:gap-0"
                >
                  <span className="font-medium text-gray-600 text-xs sm:text-sm">
                    {detail.label}:
                  </span>
                  <div className="text-left xs:text-right">
                    <span className="font-bold text-blue-700 text-sm sm:text-base block break-all">
                      {detail.value}
                    </span>
                    {detail.extra && (
                      <span className="font-medium text-gray-500 text-xs sm:text-sm break-all">
                        {detail.extra}
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer with buttons */}
        <div className="p-4 sm:p-6 flex flex-col-reverse sm:flex-row gap-2 sm:gap-3 justify-end border-t border-gray-200 bg-gray-50 rounded-b-xl">
          <button
            onClick={onCancel}
            className="w-full sm:w-auto px-4 sm:px-6 py-2.5 sm:py-3 border border-gray-300 rounded-lg font-semibold text-sm cursor-pointer transition-all duration-200 sm:min-w-[120px] bg-white text-gray-700 hover:bg-gray-50 hover:border-gray-400 disabled:opacity-60 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-gray-200"
            disabled={isLoading}
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className={`w-full sm:w-auto px-4 sm:px-6 py-2.5 sm:py-3 border-none rounded-lg font-semibold text-sm cursor-pointer transition-all duration-200 sm:min-w-[120px] focus:outline-none focus:ring-2 focus:ring-blue-300 ${confirmButtonClass}`}
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="flex items-center justify-center gap-2">
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                <span className="text-xs sm:text-sm">Processing...</span>
              </div>
            ) : (
              confirmText
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
